import "./polyfill";
import React from "react";
import "./index.css";
import {Provider} from "react-redux";
import {store} from "./_helpers";

// Disable ServiceWorker
// import registerServiceWorker from './registerServiceWorker';
import {unregister} from "./registerServiceWorker";
import {createRoot} from "react-dom/client";
import App from "./App";

unregister();

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
    <Provider store={store}>
        <App/>
    </Provider>
);